import { Variants } from "framer-motion";
import { ANIMATION_STATE, SKINNER_BOX_CONFIG, SKINNER_BOX_STATE, INTERACTION_STATE } from "./constants";

export const circleVariants: Variants = {
  [ANIMATION_STATE.IDLE]: { rotate: 0 },
  [ANIMATION_STATE.ANIMATING]: {
    rotate: 360,
    transition: { duration: 10, repeat: Infinity, ease: "linear" },
  },
};

export const containerVariants: Variants = {
  [SKINNER_BOX_STATE.IDLE]: { opacity: 1, scale: 1 },
  [SKINNER_BOX_STATE.REVEAL]: { opacity: 1, scale: 1 },
  [SKINNER_BOX_STATE.CLAIMABLE]: { opacity: 1, scale: 1 },
  [SKINNER_BOX_STATE.CLAIMED]: {
    opacity: [1, 0],
    scale: [1, 0],
    transition: {
      duration: SKINNER_BOX_CONFIG.LEAVE_ANIM_DURATION_MS / 1000,
      ease: "easeInOut",
      delay: SKINNER_BOX_CONFIG.LEAVE_ANIM_DELAY_MS / 1000,
    },
  },
};

export const claimButtonLightVariants: Variants = {
  [SKINNER_BOX_STATE.CLAIMABLE]: {
    y: [-2, 2, -2, 2, 0],
    scale: [1, 1, 1.08, 1],
    transition: {
      duration: 2,
      ease: "easeInOut",
      repeat: Infinity,
      repeatDelay: 1.7,
    },
  },
};

export const bonusTextVariants: Variants = {
  [INTERACTION_STATE.IDLE]: {
    y: [-0.7, 0, 0.7],
    transition: {
      duration: 2,
      ease: "easeInOut",
      repeat: Infinity,
      repeatDelay: 0,
    }
  },
  [INTERACTION_STATE.CLICKED]: {
    scale: [1, 1.3, 0],
    opacity: [1, 0],
    transition: {
      duration: 1.5,
      ease: "easeInOut",
    }
  },
  [INTERACTION_STATE.HIDDEN]: {
    scale: [1, 0.5, 0],
    opacity: 0,
  }
};

export const shineImageVariants: Variants = {
  [INTERACTION_STATE.IDLE]: {
    opacity: 0.9,
    filter: "brightness(1)",
    transition: { duration: 1 },
  },
  [INTERACTION_STATE.CLICKED]: {
    opacity: 1,
    filter: "brightness(1.5) saturate(1.5)",
    transition: { duration: 5 },
  },
};